// Configuration for different organization types and their actions
export const organizationConfig = {
  // Default behavior - generate Google Meet link
  default: {
    action: "generate",
    label: "Generate Google Meet Link",
    showCondition: (podSession) => !podSession.googleMeetLink,
  },

  // Crane organization - redirect to external integration
  crane: {
    action: "redirect",
    label: "Open Crane Integration",
    url: "https://www.monitoredu.live/crane",
    showCondition: () => true,
  },

  // Colibri-related organizations - redirect to Google Rooms
  colibri: {
    action: "redirect",
    label: "Open Google Meet Generator",
    url: "https://www.monitoredu.live/google-rooms",
    showCondition: () => true,
    organizationIds: [
      "colibri-real-estate",
      "superior-school-of-real-estate",
      "allied-schools",
      "hondros-college",
      "la-unified-school-district-lausd",
    ],
  },

  // Example: Add new organization types here
  // exampleOrg: {
  //   action: "redirect",
  //   label: "Custom Action",
  //   url: "https://example.com",
  //   showCondition: () => true,
  // },
};

// Helper function to get the appropriate action configuration for an organization
export const getOrganizationAction = (organizationId) => {
  if (organizationId === "crane") {
    return organizationConfig.crane;
  }

  if (organizationConfig.colibri.organizationIds.includes(organizationId)) {
    return organizationConfig.colibri;
  }

  return organizationConfig.default;
};

// Helper function to check if an organization should show any action button
export const shouldShowActionButton = (podSession) => {
  if (!podSession) return false;

  const action = getOrganizationAction(podSession.organizationId);
  return action.showCondition(podSession);
};
